/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { DateRangePicker, FocusedInputShape } from 'react-dates';
import moment from 'moment';
import 'react-dates/lib/css/_datepicker.css';
import { States } from 'services/states';
import { esferasOption, esferasOptions } from 'services/esferas_contracts';
import { getCitiesByStates } from 'services/actions/cities_actions';
import Select from 'react-select';
import { CitiesTypes, StatesTypes } from 'store/modules/online_search_store/types';
import { getAtas, SearchAtas } from 'store/modules/ata_registration_price_store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { PanelState } from 'store/modules/panel_store/types';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { Container } from './styles';

interface AtaRegistrationPriceSearchFormProps {
  setSearch: React.Dispatch<React.SetStateAction<boolean>>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setParams: React.Dispatch<any>;
}

interface IHandleDatesChange {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
}

const AtaRegistrationPriceSearchForm = (props: AtaRegistrationPriceSearchFormProps) => {
  const dispatch = useDispatch();
  const { setSearch, setParams, setPage } = props;
  const [searchBarOpened, setSearchBarOpened] = useState<boolean>(true);
  const [selectedObjeto, setSelectedObjeto] = useState('');
  const [selectedOrgao, setSelectedOrgao] = useState('');
  const [selectedIdCNL, setSelectedIdCNL] = useState('');
  const [selectedEdital, setSelectedEdital] = useState('');
  const [statesList, setStatesList] = useState<Array<StatesTypes>>([]);
  const [citiesList, setCitiesList] = useState<Array<CitiesTypes>>([]);
  const [cities, setCities] = useState<Array<CitiesTypes>>([]);
  const [selectedEsfera, setSelectedEsfera] = useState<Array<esferasOption>>([]);
  const [startDate, setStartDate] = useState<moment.Moment | null>(null);
  const [endDate, setEndDate] = useState<moment.Moment | null>(null);
  const [focusedInput, setFocusedInput] = useState<FocusedInputShape | null>(null);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const handleDatesChange = ({ startDate, endDate }: IHandleDatesChange) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };
  const esfera = selectedEsfera.map((selectedEsfera) => selectedEsfera.value);
  const state = statesList.map((statesList) => statesList.value);
  const Getcities = cities.map((cities) => cities.value);

  useEffect(() => {
    (async () => {
      const statesIds = statesList.map((state: { value: number }) => state.value);
      if (statesIds.length > 0) {
        const citiesResponse = await getCitiesByStates(statesIds);
        setCitiesList(
          citiesResponse.map((city: any) => {
            return { label: `${city.name_sub} - ${city.acronym}`, value: city.id };
          }),
        );
      }
      if (statesIds.length === 0) setCitiesList([]);
    })();
  }, [statesList]);

  const handleClick = async () => {
    setSearch(true);
    setPage(1);
    const params = {
      objeto: selectedObjeto,
      state,
      Getcities,
      id: selectedIdCNL,
      edital: selectedEdital,
      orgao: selectedOrgao,
      tipo_orgao_id: esfera,
      vigencia_inicio: startDate ? startDate.format('YYYY-MM-DD') : null,
      vigencia_fim: endDate ? endDate.format('YYYY-MM-DD') : null,
      exact_search: searchBarOpened,
    };
    dispatch(SearchAtas(params, 1));
    setParams(params);
  };

  const handleReset = async () => {
    dispatch(
      getAtas({
        page: 1,
      }),
    );
    setSelectedObjeto('');
    setStartDate(null);
    setEndDate(null);
    setSelectedEdital('');
    setSelectedIdCNL('');
    setCities([]);
    setStatesList([]);
    setSelectedOrgao('');
    setPage(1);
    setSelectedEsfera([]);
  };

  return (
    <Container>
      <div className="row">
        <div
          className={`col-12 col-lg-3 col-md-12 pr-2 filter-bar  ${
            profile.in_sample || panel?.registration_type_validation === 1 ? 'hasTopBanner' : ''
          } shadow `}
        >
          <div className="filter-form pr-2">
            <div className="row d-print-none">
              <div className="col-md-12 py-3">
                <div className="row mb-3">
                  <div className="col-md-12 pr-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-link float-right"
                      onClick={handleReset}
                    >
                      Limpar
                    </button>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="objetoSearch" className="m-0">
                      Objeto
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="objetoSearch"
                      placeholder="Pesquise por Objeto"
                      value={selectedObjeto}
                      onChange={(e) => setSelectedObjeto(e.target.value)}
                    />
                  </div>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={searchBarOpened}
                    id="exact_search"
                    onChange={(e) => setSearchBarOpened(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="exact_search">
                    Busca Exata
                  </label>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="stateSearch" className="m-0">
                      Estado
                    </label>
                    <Select
                      name="StateSearch"
                      isMulti
                      value={statesList || ''}
                      closeMenuOnSelect={false}
                      onChange={(event) => setStatesList([...event])}
                      options={States}
                      placeholder="Selecione os Estados"
                      className="basic-multi-select"
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-between col-md-12 p-0 mb-3">
                  <div className="float-right date-template">
                    <button
                      type="button"
                      className="btn btn-sm btn-link pr-0"
                      onClick={() => setStatesList(States)}
                    >
                      Todos os Estados
                    </button>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="citySearch" className="m-0">
                      Cidade
                    </label>
                    <Select
                      name="CitySearch"
                      isMulti
                      closeMenuOnSelect={false}
                      value={cities || ''}
                      onChange={(event) => setCities([...event])}
                      options={citiesList}
                      noOptionsMessage={() => 'Selecione um estado'}
                      placeholder="Selecione as Cidades"
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="editalSearch" className="m-0">
                      Nº Edital
                    </label>
                    <input
                      type="text"
                      id="editalSearch"
                      className="form-control"
                      placeholder="Pesquise por Nº Edital"
                      value={selectedEdital}
                      onChange={(e) => setSelectedEdital(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="idSearch" className="m-0">
                      Nº Conlicitação
                    </label>
                    <input
                      type="text"
                      id="idSearch"
                      className="form-control"
                      placeholder="Pesquise por Nº Conlicitação"
                      value={selectedIdCNL}
                      onChange={(e) => setSelectedIdCNL(e.target.value)}
                    />
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div>
                      <label htmlFor="vigencia" className="m-0">
                        Vigência
                      </label>
                    </div>
                    <DateRangePicker
                      disabled={false}
                      startDate={startDate}
                      startDateId="daterangepicker_start_date"
                      endDate={endDate}
                      endDateId="daterangepicker_end_date"
                      onDatesChange={handleDatesChange}
                      focusedInput={focusedInput}
                      onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
                      startDatePlaceholderText="De"
                      endDatePlaceholderText="Até"
                      hideKeyboardShortcutsPanel
                      displayFormat="DD/MM/YYYY"
                      isOutsideRange={() => false}
                      showClearDates
                      small
                      numberOfMonths={1}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="objetoSearch" className="m-0">
                      Órgão
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="objetoSearch"
                      placeholder="Pesquise por Órgão"
                      value={selectedOrgao}
                      onChange={(e) => setSelectedOrgao(e.target.value)}
                    />
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label className="m-0">Esfera</label>
                    <Select
                      isMulti
                      name="esferas"
                      options={esferasOptions}
                      value={selectedEsfera}
                      placeholder="Selecione as Esferas"
                      classNamePrefix="select"
                      className="basic-multi-select"
                      onChange={(event) => setSelectedEsfera([...event])}
                    />
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3 px-2 py-3 filter-button d-print-none">
            <button type="button" className="btn btn-primary w-100" onClick={() => handleClick()}>
              Pesquisar
            </button>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default AtaRegistrationPriceSearchForm;
